import { useRef } from 'react';
import PropTypes from 'prop-types';
import useInvoice from 'Hooks/useInvoice';
import PreviewFile from 'Components/Molecules/PreviewFile/PreviewFile';
import InvoiceQuickEditorDrawerPreviewEmpty from './InvoiceQuickEditorDrawerPreviewEmpty';
import { trackError } from 'Utils/errorMonitoring';

export default function InvoiceQuickEditorDrawerPreviewDesktop(props) {
    const { id } = props;

    const { invoice, isLoading } = useInvoice(id);
    const iframeRef = useRef(null);

    const handlePrint = async () => {
        try {
            const response = await fetch(invoice?.file_url);
            const blob = await response.blob();
            const fileURL = URL.createObjectURL(blob);

            iframeRef.current.src = fileURL;
            iframeRef.current.onload = () => {
                iframeRef.current.contentWindow.focus();
                iframeRef.current.contentWindow.print();
            };
        } catch (error) {
            trackError(error);
        }
    };

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = invoice?.file_url;
        link.download = `${id}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    if (!isLoading && !invoice?.file_url) {
        return <InvoiceQuickEditorDrawerPreviewEmpty />;
    }

    return (
        <>
            <div className="hidden">
                <iframe ref={iframeRef} src="" title="invoice-print" />
            </div>
            <PreviewFile
                loading={isLoading}
                url={invoice?.file_url}
                className="h-screen"
                onPrint={handlePrint}
                onDownload={handleDownload}
            />
        </>
    );
}

InvoiceQuickEditorDrawerPreviewDesktop.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    compactMode: PropTypes.bool,
};
